const ASSETS = '/gen-ai-creative/assets/landing';

export const GEN_AI_CREATIVE_LANDING = {
  path: '/gen-ai-creative',
  hero: {
    eyebrow: 'Gen AI',
    titleLines: ['Инфраструктура', 'для команд'],
    description:
      'Помогаем оплатить ИИ-сервисы в одном месте. Быстро, удобно, в рублях, с закрывающими документами.',
    cta: 'Обсудить задачу',
    photo: `${ASSETS}/hero-photo.webp`,
    bulb: `${ASSETS}/hero-bulb.webp`,
    key: `${ASSETS}/hero-key.webp`,
  },
  pains: {
    title: 'С чем сталкиваются компании при внедрении ИИ',
    items: [
      {
        id: 'hands',
        icon: `${ASSETS}/pain-hands.webp`,
        text: 'Не хватает рук для создания большого потока контента',
      },
      {
        id: 'cards',
        icon: `${ASSETS}/pain-cards.webp`,
        text: 'Сотрудники пользуются ИИ, но оплачивают все с личных карт',
      },
      {
        id: 'process',
        icon: `${ASSETS}/pain-process.webp`,
        text: 'Нет единого процесса работы с генеративным ИИ',
      },
      {
        id: 'shield',
        icon: `${ASSETS}/pain-shield.webp`,
        text: 'Непонятно, какой сервис будет эффективнее и безопаснее',
      },
    ],
    offer: {
      label: 'Специальное предложение',
      title: 'Покупаете каждый месяц подписки, а хотите годовые со скидкой до 40%?',
      badgeValue: '-40%',
      badgeLabel: 'Экономия',
    },
  },
  benefits: {
    title: 'Чем можем помочь',
    items: [
      {
        id: 'licenses',
        tag: 'Лицензии и документы',
        title: 'Закупим лицензии и предоставим закрывающие документы',
        description: 'Подготовим смету, оплатим в рублях, пришлём счета-фактуры',
        image: `${ASSETS}/benefit-docs.webp`,
      },
      {
        id: 'process',
        tag: 'Оптимизация процесса',
        title: 'Выстроим прозрачный процесс работы',
        description:
          'Проведем аудит взаимодействия креативной команды с ИИ, подберем нужные сервисы под задачи, оптимизируем расходы',
        image: `${ASSETS}/benefit-process.webp`,
      },
      {
        id: 'budget',
        tag: 'Бюджетная выгода',
        title: 'Сэкономим бюджет на сервисы',
        description:
          'Поможем подобрать наиболее выгодные тарифы и сэкономить до 40% от розничных цен',
        image: `${ASSETS}/benefit-budget.webp`,
      },
    ],
  },
  timeline: {
    title: 'Как проходит пилот',
    duration: '4–8 недель',
    steps: [
      {
        id: 'audit',
        number: '01',
        title: 'Аудит',
        description: 'Смотрим, как сейчас команда работает с нейросетями',
      },
      {
        id: 'workshop',
        number: '02',
        title: 'Воркшоп',
        description: 'Пробуем на реальных задачах',
      },
      {
        id: 'kp',
        number: '03',
        title: 'КП',
        description: 'Фиксируем решение и стоимость',
      },
      {
        id: 'harness',
        number: '04',
        title: 'Harness',
        description: 'Настраиваем на одном пайплайне',
      },
      {
        id: 'result',
        number: '05',
        title: 'Результат',
        description: 'Сравниваем цену до и после',
      },
    ],
  },
  metrics: {
    title: 'Что мы считаем',
    items: [
      {
        id: 'licenses',
        icon: `${ASSETS}/metric-licenses.webp`,
        title: 'Лицензии',
        description: 'Сколько платите сейчас за разрозненные сервисы',
      },
      {
        id: 'time',
        icon: `${ASSETS}/metric-time.webp`,
        title: 'Время',
        description: 'Сколько уходит на ручную работу с нейросетями',
      },
      {
        id: 'tokens',
        icon: `${ASSETS}/metric-tokens.webp`,
        title: 'Токены',
        description: 'Где расходуются впустую без оптимизации',
      },
      {
        id: 'risks',
        icon: `${ASSETS}/metric-risks.webp`,
        title: 'Риски',
        description: 'Оплата с личных карт, отсутствие закрывающих документов',
      },
    ],
  },
  cases: {
    title: 'Реальные кейсы',
    items: [
      {
        id: 'knauf',
        company: 'KNAUF',
        logo: `${ASSETS}/logo-knauf.svg`,
        logoBg: 'dark',
        result: 'Результат: ×3 контента, −30% бюджета',
        title: 'Внедрение ИИ-ассистентов для маркетинговой команды',
        body:
          'Благодаря Jay Copilot КНАУФ ускорил выполнение маркетинговых задач: упростился документооборот и ушла необходимость отчуждать авторские права или привлекать подрядчиков. С приложением «Иллюстратор» компания быстро создает изображения для блога, SMM и креативных проектов. А «Копирайтер» помогает оперативно готовить посты для соцсетей и статьи для блога. Теперь создание контента для бренда через AI обходится компании в 8 раз дешевле и в 2 раза быстрее, чем при заказе у подрядчиков.',
      },
      {
        id: 'pragmatica',
        company: 'PRAGMATICA',
        logo: `${ASSETS}/logo-pragmatica.svg`,
        logoBg: 'dark',
        result: 'Результат: −40% расходов, единый договор',
        title: 'Оптимизация и контроль закупок ИИ-сервисов',
        body:
          'Pragmatica закупала подписки на Krea, Cursor и Figma Weave хаотично с личных карт сотрудников. Мы перевели все аккаунты на годовые лицензии через единый корпоративный договор с оплатой в рублях. Обеспечили полную прозрачность расходов и сэкономили 40% бюджета',
      },
      {
        id: 'lenkabel',
        company: 'Ленкабель',
        logo: `${ASSETS}/logo-lenkabel.png`,
        logoBg: 'dark',
        result: 'Результат: цикл 40→10, AI-first процесс',
        title: 'Создание AI-first процесса для тендерной площадки',
        body:
          'Помогли команде Ленкабель выстроить автоматический пайплайн сбора и анализа тендерной информации с использованием ИИ-агентов на всех этапах — от сбора информации по заказам и продажам до накопления в базе данных. Сократили цикл работы с тендерной площадкой с ROI 400%.',
      },
    ],
  },
  trust: {
    title: 'Нам доверяют',
    note: 'Часть кейсов — под NDA, детали обсудим на созвоне',
    logos: [
      { name: 'Сбербанк' },
      { name: 'Ozon' },
      { name: 'VK' },
      { name: 'ИТМО' },
      { name: 'Яндекс' },
    ],
  },
  contact: {
    title: 'Обсудим подробнее?',
    description: 'Оставьте контакты — вернёмся с планом и стоимостью',
    deco: `${ASSETS}/contact-deco.webp`,
    formTitle: 'Оставить заявку',
    formDescription:
      'Выберите способ связи — обсудим задачу и подберём решение',
    submitLabel: 'Оставить заявку',
  },
};

export function buildGenAiCreativeLandingStructuredData() {
  const pageUrl = `https://antologia.tech${GEN_AI_CREATIVE_LANDING.path}`;
  const timelineSteps = GEN_AI_CREATIVE_LANDING.timeline.steps;
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Главная',
          item: 'https://antologia.tech/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Gen AI инфраструктура для команд',
          item: pageUrl,
        },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Gen AI инфраструктура для команд',
      serviceType: 'Закупка и внедрение Gen AI для команд',
      description:
        'Помогаем оплатить ИИ-сервисы в одном месте. Быстро, удобно, в рублях, с закрывающими документами. Пилот 4–8 недель: аудит, воркшоп, КП, harness и сравнение цены до и после.',
      provider: {
        '@type': 'Organization',
        name: 'Антология',
        url: 'https://antologia.tech',
      },
      areaServed: {
        '@type': 'Country',
        name: 'Россия',
      },
      audience: {
        '@type': 'BusinessAudience',
        audienceType: 'Креативные команды и маркетинг B2B',
      },
      url: pageUrl,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: GEN_AI_CREATIVE_LANDING.timeline.title,
      description: `Пилот ${GEN_AI_CREATIVE_LANDING.timeline.duration}: от аудита до сравнения цены до и после.`,
      totalTime: 'P8W',
      step: timelineSteps.map((item, index) => ({
        '@type': 'HowToStep',
        position: index + 1,
        name: item.title,
        text: item.description,
      })),
    },
  ];
}
